import { Component } from "preact";
import { createPortal } from 'preact/compat';
import Rest from "../helper/rest";
import MessagePropagator from "../helper/message-propagator";
import ActionBtn from "./action-btn";
import Window from "./window";
import { FrontendConfig } from '../../src/models/shard-frontend-config'
import { ConfigContext } from '../contexts/config';
import sessionCache from "../helper/session-cache";
import socket from "../helper/socket";

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bodyEl: null,
            shard: null,
            tenant: null,
            config: null,
            windowOpen: false,
            cssOverrideUrl: null,
            hideAll: false,
            resumeChat: false,
        };

        if (typeof document !== "undefined") {
            this.state.bodyEl = document.getElementsByTagName('body')[0];
        }

        if (typeof window !== "undefined") {
            const urlParams = new URLSearchParams(window.location.search);
            const shard = urlParams.get('shard');
            if (shard === null) {
                // No shard param detected, exiting...
                return;
            }

            // Validate shard & get config
            Rest.getShardInformation(shard, urlParams.get('tenant'), (shardFrontendConfig, error) => {
                if (error !== null || !(shardFrontendConfig instanceof FrontendConfig)) {
                    // Error getting shard info, exiting...
                    return;
                }

                // Base for next "setState"
                const nextStateSet = {
                    shard: shard,
                    tenant: urlParams.get('tenant'),
                    config: shardFrontendConfig,
                    windowOpen: shardFrontendConfig.windowOpenOnInit
                };

                // Check wether there is a session id cached, we can work with
                const sessionId = sessionCache.getSessionId();
                if (sessionId !== null) {
                    socket.resume(sessionId, (success, history) => {
                        if (success) {
                            nextStateSet.resumeChat = true;
                            nextStateSet.windowOpen = true;

                            sessionCache.verifyHistory(history);
                        } else {
                            // As the session cannot be resumed, we clear sessionCache
                            // This is also done, because history persistence is deactivated if no sessionId is set
                            sessionCache.clear();
                        }

                        this.setState(nextStateSet);
                    })
                } else {
                    this.setState(nextStateSet);
                }
            })

            // Meanwhile, check for cssOverride
            const cssOverrideUrl = urlParams.get('cssOverride');
            if (cssOverrideUrl !== null) {
                this.state.cssOverrideUrl = cssOverrideUrl;
                this.state.hideAll = true;
            }
        }
    }

    cssOverrideLoaded() {
        this.setState({hideAll: false});
    }

    render() {
        let inner;
        let addedMargin = 0;

        if (this.state.shard !== null && !this.state.hideAll) {
            const sizing = this.state.config.getDisplaySizing();
            addedMargin = sizing.addedMargin;

            if (this.state.windowOpen) {
                MessagePropagator.postSizing(
                    sizing.windowHeight + (addedMargin * 2),
                    sizing.windowWidth + (addedMargin * 2)
                );
            } else {
                MessagePropagator.postSizing(
                    sizing.actionButtonHeight + (addedMargin * 2),
                    sizing.actionButtonWidth + (addedMargin * 2)
                );
            }

            inner =
            <ConfigContext.Provider value={this.state.config}>
                <Window
                    show={this.state.windowOpen}
                    shard={this.state.shard}
                    tenant={this.state.tenant}
                    onClose={() => this.setState({ windowOpen: false })}
                    height={sizing.windowHeight}
                    width={sizing.windowWidth}
                    resumeChat={this.state.resumeChat}
                />
                <ActionBtn
                    show={!this.state.windowOpen}
                    onAction={() => this.setState({ windowOpen: true })}
                    height={sizing.actionButtonHeight}
                    width={sizing.actionButtonWidth}
                />
            </ConfigContext.Provider>;
        }

        return (
            <Fragment>
                {this.state.cssOverrideUrl && this.state.bodyEl &&
                    createPortal(
                        <link type={'text/css'} rel={'stylesheet'} href={this.state.cssOverrideUrl} onLoad={this.cssOverrideLoaded.bind(this)}/>,
                        this.state.bodyEl
                    )
                }
                <div id="main" style={{margin: addedMargin + 'px'}}>
                    {inner}
                </div>
            </Fragment>
        )
    }
}